<template>
  <div class="conteudo-modal">
    <div  id="app-bpmn">
      <div id="bpmn-container"></div>
    </div>
    <div class="informacao">
      <div class="passou box"><p class="texto-white">{{`${this.setorOuStatus} pelo qual o processo já passou`}}</p></div>
      <div class="pendente box"><p class="texto-black">{{`${this.setorOuStatus} pelo qual o processo ainda não passou`}}</p></div>
      <div class="atual box"><p class="texto-white">{{`${this.setorOuStatus} atua`}}l</p></div>
    </div>
    <div class="voltar" v-if="isMicro">
      <span
        class="btn-voltar"
        @click="reloadMacro"
        type="button"
        aria-label="Voltar para o fluxo macro"
      >
       <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 6L4 12L10 18"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 12H20"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
        />
      </svg>
      </span>
    </div>
  </div>
</template>

<script>
import axios from '@/utils/api'
import BpmnViewer from 'bpmn-js/lib/NavigatedViewer'
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css'

export default {
  name: 'BpmnViewer',
  props: ['numeroProcesso', 'tipoProcesso'],
  data () {
    return {
      viewer: null,
      typeView: 'MACRO', // MACRO | MICRO
      xmlView: null,
      fluxos: null
    }
  },
  async mounted () {
    await this.loadXMLFluxo()
    await this.renderBpmn()
  },
  methods: {
    async loadXMLFluxo () {
      const { xml, fluxosProcesso } = await axios({
        method: 'get',
        url: `fluxoXml/xml?numeroProcesso=${this.numeroProcesso}&tipoProcesso=${this.tipoProcesso}`
      })
      this.typeView = 'MACRO'
      this.xmlView = xml
      this.fluxos = fluxosProcesso
    },
    async loadXMLSubFluxo (calledElement, subFluxoId) {
      const { xml, fluxosProcesso } = await axios({
        method: 'get',
        url: `fluxoXml/sub/xml?calledElement=${calledElement}&numeroProcesso=${this.numeroProcesso}&subFluxoId=${subFluxoId}`
      })
      this.typeView = 'MICRO'
      this.xmlView = xml
      this.fluxos = fluxosProcesso
    },
    async renderBpmn () {
      this.destroyViewer()
      this.mountViewer()

      await this.viewer.importXML(this.xmlView, (err) => {
        if (err) {
          console.error('Erro ao renderizar o XML do fluxo:', err)
        } else {
          try {
            const canvas = this.viewer.get('canvas')
            canvas.zoom(0.6)

            if (this.isMacro) {
              const eventBus = this.viewer.get('eventBus')

              eventBus.on('element.dblclick', (e) => {
                const el = e.element
                if (!el) return

                if (el.waypoints) return

                if (el.type && el.type === 'bpmn:CallActivity') {
                  const calledElement = el?.businessObject?.calledElement
                  this.onClickCalledElement(calledElement, el?.id)
                }
              })
            }

            let setorAtual = false

            const elementsCollection = document.getElementsByClassName('djs-element')
            for (let i = 0; i < elementsCollection.length; i++) {
              const element = elementsCollection[i]
              const elementId = element.getAttribute('data-element-id')

              let elements = document.getElementsByTagName('rect')

              for (let i = 0; i < elements.length; i++) {
                let rectElement = elements[i]
                let width = rectElement.getAttribute('width')
                if (parseInt(width) === 14) {
                  rectElement.remove()
                }
              }

              let icones = document.getElementsByTagName('path')

              for (let i = 0; i < icones.length; i++) {
                let rectElement = icones[i]
                let data = rectElement.getAttribute('data-marker')
                if (data === 'sub-process') {
                  rectElement.remove()
                }
              }

              if (this.fluxos.find(f => f.idFluxo === elementId) && !element.getAttribute('class').includes('djs-connection')) {
                const rectElement = element.querySelector('rect')
                const textElement = element.querySelector('text')
                const g = element.querySelector('g')

                if (rectElement && !g.querySelector('polygon') && !g.querySelector('circle') && this.fluxos.find(f => f.idFluxo === elementId)) {
                  rectElement.style.fill = 'rgb(134, 134, 134)'
                  rectElement.style.stroke = 'rgb(134, 134, 134)'
                }
                if (textElement && !g.querySelector('polygon') && !g.querySelector('circle')) {
                  textElement.style.fill = 'white'
                }
                if (rectElement && !g.querySelector('polygon') && !g.querySelector('circle') && this.fluxos[this.fluxos.length - 1].idFluxo === elementId) {
                  setorAtual = true
                  if (this.isMacro || this.fluxos.find(f => f.idFluxo === elementId)?.atual) {
                    rectElement.style.fill = 'rgb(40, 159, 97)'
                    rectElement.style.stroke = 'rgb(40, 159, 97)'
                  }
                }
                if (this.fluxos.find(f => f.idFluxo === elementId)?.atual) {
                  rectElement.style.fill = 'rgb(40, 159, 97)'
                  rectElement.style.stroke = 'rgb(40, 159, 97)'
                }
              }
            }
            if (!setorAtual && this.fluxos.length > 0 && this.isMacro) {
              let rectStyle = null
              let maiorIndex = -1
              for (let i = 0; i < elementsCollection.length; i++) {
                const element = elementsCollection[i]
                const elementId = element.getAttribute('data-element-id')

                if (this.fluxos.find(f => f.idFluxo === elementId) && !element.getAttribute('class').includes('djs-connection')) {
                  const rectElement = element.querySelector('rect')
                  const g = element.querySelector('g')
                  if (rectElement && !g.querySelector('polygon') && !g.querySelector('circle')) {
                    const currentIndex = this.fluxos.findIndex((f) => f.idFluxo === elementId)
                    if (currentIndex > maiorIndex && !this.fluxos[currentIndex].idFluxo.includes('ARQUIVAMENTO')) {
                      maiorIndex = currentIndex
                      rectStyle = rectElement
                    }
                  }
                }
              }
              if (rectStyle) {
                rectStyle.style.fill = 'rgb(40, 159, 97)'
                rectStyle.style.stroke = 'rgb(40, 159, 97)'
              }
            }
          } catch (err) {
            console.log('Erro inner renderBpmn:', err)
          }
        }
      })
    },
    mountViewer () {
      const container = document.getElementById('bpmn-container')

      this.viewer = new BpmnViewer({
        container: container
      })
    },
    destroyViewer () {
      if (this.viewer) {
        this.viewer.destroy()
        this.viewer = null
      }

      const container = document.getElementById('bpmn-container')
      if (container) {
        container.innerHTML = ''
      }
    },
    async onClickCalledElement (calledElement, id) {
      if (calledElement && id) {
        await this.loadXMLSubFluxo(calledElement, id)
        await this.renderBpmn()
      }
    },
    async reloadMacro () {
      await this.loadXMLFluxo()
      await this.renderBpmn()
    }
  },
  computed: {
    isMacro () {
      return this.typeView === 'MACRO'
    },
    isMicro () {
      return this.typeView === 'MICRO'
    },
    setorOuStatus () {
      return this.isMacro ? 'Setor' : 'Status'
    }
  }
}
</script>
<style scoped>

#bpmn-container {
  width: 100%;
  height: 530px;
}

#app-bpmn {
  width: 100%;
  height: 510px;
}

#pane-VISUALIZAR_FLUXO {
  height: 500px !important;
}

.bpmn-highlight {
  background-color: green !important
}

.box {
  width: 130px;
  height: 60px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  margin: 5px;
}

.pendente {
  background-color: rgb(255, 255, 255);
  border: 3px solid black;
}

.texto-white {
  color: rgb(255, 255, 255) !important;
  font-size: 10px;
}

.texto-black {
  color: rgb(3, 3, 3) !important;
  font-size: 10px;
}

.conteudo-modal {
  position: relative;
}

.informacao {
  position: absolute;
  top: 0;
  right: 10px;
  box-sizing: border-box;
}

.voltar {
  position: absolute;
  top: 0;
  left: 10px;
}

.btn-voltar {
  width: 40px;
  height: 40px;
  color: #333;
  font-size: 28px;
  font-weight: 700;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 0.15s ease;
}

.btn-voltar:hover {
  color: #000000;
  transform: scale(1.05);
}

.btn-voltar:active {
  transform: scale(0.95);
}

.passou {
  background-color: rgb(134, 134, 134);
  border: 3px solid rgb(134, 134, 134);
}

.atual {
  background-color: rgb(40, 159, 97);
  border: 3px solid rgb(40, 159, 97);
}
</style>



// WEBPACK FOOTER //
// src/components/AppBpmnViewer.vue